// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LocalizationController {
   $scope: any
   localizationService: any
   constructor($scope: any, localizationService: any) {

      this.$scope = $scope
      this.localizationService = localizationService
      this.$scope.localization = this.localizationService.localization
   }
}

LocalizationController.$inject = ['$scope', 'localizationService']

angular.module('summonApp.controllers')
   .controller('LocalizationCtrl', LocalizationController)
